import { generateTypes } from '@evmos/eip712';
import { Any } from '@bufbuild/protobuf';
import {
  createAnyMessage,
} from '@evmos/proto';
import { TxContext, TxPayload, createTransactionPayload } from '@evmos/transactions';
import { EIP712TypedData } from '@evmos/transactions/dist/messages/base';
import { MsgSubmitProposal } from 'cosmjs-types/cosmos/gov/v1beta1/tx';
import { ParameterChangeProposal } from 'cosmjs-types/cosmos/params/v1beta1/params';
import { MsgSubmitProposal as MsgSubmitProposalProto } from '../proto/v1beta1/tx_pb.js';
import { Coin } from '../proto/v1beta1/coin_pb.js';

const CREATE_MSG_SUBMIT_PROPOSAL_TYPES = (params: MsgSubmitProposal) => ({
  TypeContentValue: [
    { name: 'title', type: 'string' },
    { name: 'description', type: 'string' },
    { name: 'changes', type: 'TypeContentValueChanges[]' },
  ],
  TypeContentValueChanges: [
    { name: 'subspace', type: 'string' },
    { name: 'key', type: 'string' },
    { name: 'value', type: 'string' },
  ],
  TypeInitialDeposit: [
    { name: 'denom', type: 'string' },
    { name: 'amount', type: 'string' },
  ],
  MsgValue: [
    { name: 'content', type: 'TypeContent' },
    { name: 'initial_deposit', type: 'TypeInitialDeposit[]' },
    { name: 'proposer', type: 'string' },
  ],
  TypeContent: [
    { name: 'type', type: 'string' },
    { name: 'value', type: 'TypeContentValue' },
  ],
});

export const createTxMsgSubmitProposal = (context: TxContext, params: MsgSubmitProposal): TxPayload => {
  console.log('>>>>>>>>>>>', params);
  const typedData = createEIP712MsgSubmitProposal(context, params);
  console.log('==========', typedData);
  const cosmosMsg = createCosmosMsgSubmitProposal(context, params);
  console.log('<<<<<<<<<<<<', cosmosMsg);
  return createTransactionPayload(context, typedData, cosmosMsg);
};

const createEIP712MsgSubmitProposal = (context: TxContext, params: MsgSubmitProposal): EIP712TypedData => {
  const types = generateTypes(CREATE_MSG_SUBMIT_PROPOSAL_TYPES(params));
  const message = createMsgSubmitProposal(params);
  return { types, message };
};

function stringToUint8Array(str: string) {
  const utf8 = [];
  for (let i = 0; i < str.length; i++) {
    let charCode = str.charCodeAt(i);
    if (charCode < 0x80) {
      utf8.push(charCode);
    } else if (charCode < 0x800) {
      utf8.push(0xc0 | (charCode >> 6), 0x80 | (charCode & 0x3f));
    } else if (charCode < 0xd800 || charCode >= 0xe000) {
      utf8.push(
        0xe0 | (charCode >> 12),
        0x80 | ((charCode >> 6) & 0x3f),
        0x80 | (charCode & 0x3f)
      );
    } else {
      // Surrogate pair
      i++;
      charCode = 0x10000 + (((charCode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
      utf8.push(
        0xf0 | (charCode >> 18),
        0x80 | ((charCode >> 12) & 0x3f),
        0x80 | ((charCode >> 6) & 0x3f),
        0x80 | (charCode & 0x3f)
      );
    }
  }
  return new Uint8Array(utf8);
}

const createCosmosMsgSubmitProposal = (context: TxContext, params: MsgSubmitProposal): any => {
  const anyMessage = createAnyMessage({
    path: params.content?.typeUrl.replace('/', '') || '',
    message: {
      toBinary: () => {
        const content = params.content && ParameterChangeProposal.decode(params.content.value);
        const jsonString = JSON.stringify({
          type: params.content?.typeUrl,
          value: {
            title: content?.title,
            description: content?.description,
            changes: content?.changes.map((item) => ({
              subspace: item.subspace,
              key: item.key,
              value: item.value,
            })),
          },
        });
        const binary = stringToUint8Array(jsonString);
        return binary;
        // params.content?.value as any
      }
    } as any
  });
  console.log(111111111, anyMessage);
  const initialDeposit = new Coin({
    denom: params.initialDeposit[0].denom || '',
    amount: params.initialDeposit[0].amount || 0,
  });
  const msg = new MsgSubmitProposalProto({
    content: anyMessage,
    initialDeposit: [ initialDeposit ],
    proposer: params.proposer,
  });
  return {
    message: msg,
    path: MsgSubmitProposalProto.typeName,
  };
};

export function createMsgSubmitProposal(params: MsgSubmitProposal): object | object[] {
  console.log(444444)
  const content = params.content && ParameterChangeProposal.decode(params.content.value);
  return {
    type: 'cosmos-sdk/MsgSubmitProposal',
    value: {
      content: {
        type: params.content?.typeUrl,
        value: {
          title: content?.title,
          description: content?.description,
          changes: content?.changes.map((item) => ({
            subspace: item.subspace,
            key: item.key,
            value: item.value,
          })),
        },
      },
      initial_deposit: [
        {
          amount: params.initialDeposit[0].amount || 0,
          denom: params.initialDeposit[0].denom || '',
        },
      ],
      proposer: params.proposer,
    },
  };
}


